<template>
    <div class="testpasscart">
      <div class="conbox"></div>
      <div class="item_box">
        <el-input
          placeholder="输入准考证号"
          v-model="input"
          clearable
        >
        </el-input>
        <div class="content">请选择网络状态较好时进行考试，考试开始后，请不要点击试卷以外区域，以免考试中断。</div>
        <div class="confrimBtn">
          <el-button type="primary" @click="gosubmit">开始考试</el-button>
        </div>
      </div>
    </div>
</template>

<script>
import { goExchangeCode } from '../../api/index'
export default {
  name: 'gotest',
  data () {
    return {
      input: '',
      isDisable: true
    }
  },
  mounted () {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
  },
  methods: {
    gosubmit () {
      console.log(this.input)
      if (this.input === '') {
        this.$message.error('请输入准考证号')
      } else {
        goExchangeCode({
          exchangeCode: this.input // 准考证号
        }).then(res => {
          console.log(res, '//////////')
          if (res.success === '1001') {
            this.$router.push({
              name: 'goChess',
              params: {
                id: res.enrolls.enrollGradeId,
                name: res.enrolls.name,
                levelexam: res.enrolls.title,
                exchangCode: res.enrolls.exchangeCode,
                testId: res.enrolls.id
              }
            })
          } else {
            this.$message.error(res.error)
            this.input = ''
          }
        }).catch((error) => {
          // error
          console.log(error)
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/base.scss";
  @import "../../assets/scss/mixin.scss";
  @import "../../assets/scss/config.scss";
  .testpasscart{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #99a9bf;
    @include bgImg(100%,100%,'../../assets/imgs/bgc.png',100% 100%);
    .conbox{
      width: 538px;
      height: 349px;
      background: #FFFFFF;
      opacity: 0.77;
      border-radius: 7px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
    .item_box{
      width: 538px;
      height: 349px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      padding: 70px 50px;
      box-sizing: border-box;
      .content{
        width: 325px;
        height: 36px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin: auto;
        margin-top: 33px;
      }
      .confrimBtn{
        width: 100%;
        margin: auto;
        margin-top: 35px;
        text-align: center;
        .el-button{
          width: 183px;
          height: 52px;
          border-radius: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/go_test/gotest.vue